export default class DateTimeSv extends Date {
    override toString() {
        if (this.isValid()) return this.toLocaleString('sv-SE');
        return '';
    }
    override toJSON(key?: any) {
        if (this.isValid()) return this.toISOString();
        return null as unknown as string;
    }
}